import CacheTimeDisplay from './CacheTimeDisplay';

export default CacheTimeDisplay;
